import request from 'axios';
import { getClientAuthHeader } from '../../client/token';
import { loadAction } from '../helpers/utils';

export function clientsUpdateColumnsAction(headers) {
    return {
        types: ['CLIENTS_COLUMNS_SET_REQUEST', 'CLIENTS_COLUMNS_SET_SUCCESS', 'CLIENTS_COLUMNS_SET_FAILURE'],
        headers,
        promise: request.put('/api/v1/config/clients/headers', headers, getClientAuthHeader())
    };
}

// `paging` ({ page, pageSize, sort, desc }) loads one page for the contacts table. Without it the full
// list is loaded (contact pickers, search dialogs).
export function clientsLoadAction(query, filter = undefined, archived = false, paging = undefined) {
    let searchRequest = loadAction('/api/v1/client/all', query, filter, archived);
    if (paging) {
        searchRequest += `${searchRequest.includes('?') ? '&' : '?'}page=${paging.page}&pageSize=${paging.pageSize}`;
        if (paging.append) {
            // Later pages do not need the tasks and stats again.
            searchRequest += '&more=true';
        }
        if (paging.sort) {
            searchRequest += `&sort=${encodeURIComponent(paging.sort)}&desc=${!!paging.desc}`;
        }
    }

    return {
        types: ['CLIENTS_LOAD_REQUEST', 'CLIENTS_LOAD_SUCCESS', 'CLIENTS_LOAD_FAILURE'],
        paged: !!paging,
        append: !!(paging && paging.append),
        promise: request.get(searchRequest, getClientAuthHeader())
    };
}

export function clientsPagingAction(paging) {
    return {
        type: 'CLIENTS_PAGING',
        paging
    };
}

export function contactsLoadAction() {
    return {
        types: ['CONTACTS_LOAD_REQUEST', 'CONTACTS_LOAD_SUCCESS', 'CONTACTS_LOAD_FAILURE'],
        promise: request.get('/api/v1/contact/all', getClientAuthHeader())
    };
}

export function clientNewAction() {
    return {
        type: 'CLIENT_NEW'
    };
}

export function clientsAllAction() {
    return {
        type: 'CLIENTS_ALL'
    };
}

export function clientSavingNeededAction(savingNeeded) {
    return {
        type: 'CLIENT_SAVING_NEEDED',
        savingNeeded
    };
}

// `dataChanged` is for saves/imports/deletes (not searches): the full client list used by the
// contact pickers must be reloaded too.
export function clientsRefreshNeededAction(refreshNeeded, dataChanged = false) {
    return {
        type: 'CLIENTS_REFRESH_NEEDED',
        refreshNeeded,
        dataChanged
    };
}

export function clientsFilterAction(filter) {
    return {
        type: 'CLIENTS_FILTER',
        filter
    };
}

export function clientDeleteAction(clientId, permanentlyDelete) {
    const types = ['CLIENT_DELETE_ID_REQUEST', 'CLIENT_DELETE_ID_SUCCESS', 'CLIENT_DELETE_ID_FAILURE'];
    if (!permanentlyDelete) {
        return {
            types,
            promise: request.delete('/api/v1/client/' + clientId, getClientAuthHeader())
        };
    }
       
    return {
        types,
        promise: request.delete('/api/v1/client/permanent/' + clientId, getClientAuthHeader())
    };
}

export function clientsDeleteAction(clientIds, permanentlyDelete) {
    const types = ['CLIENTS_DELETE_IDS_REQUEST', 'CLIENTS_DELETE_IDS_SUCCESS', 'CLIENTS_DELETE_IDS_FAILURE'];
    const data = {
        clientIds,
        permanentlyDelete
    };

    return {
        types,
        promise: request.post('/api/v1/clients/archive', data, getClientAuthHeader())
    };
}

export function clientEditAction(editedClient) {
    return {
        type: 'CLIENT_EDIT',
        current: editedClient,
    };
}


export function clientCasesEditAction(editedClientCases) {
    return {
        type: 'CLIENT_CASES_EDIT',
        cases: editedClientCases,
    };
}

export function clientEditIdAction(id, initialClient = {}) {
    return {
        types: ['CLIENT_EDIT_ID_REQUEST', 'CLIENT_EDIT_ID_SUCCESS', 'CLIENT_EDIT_ID_FAILURE'],
        initialClient,
        promise: request.get('/api/v1/client/' + id, getClientAuthHeader())
    };
}

export function clientTypeSet(clientType) {
    return {
        type: 'CLIENT_TYPE_SET',
        clientType
    };
}
